import React from "react";
import { useLayoutContext } from "context";
import useStyles from "./styles";

type HeaderContainerProps = {
  layoutType: "layout" | "authLayout" | "giessPlan";
  children: React.ReactNode;
};

export const HeaderContainer: React.FC<HeaderContainerProps> = ({
  layoutType,
  children,
}) => {
  const layoutContext = useLayoutContext();
  const { classes, cx } = useStyles();
  return (
    <header
      className={cx(
        classes.headerContainer,
        layoutType === "authLayout" || layoutType === "giessPlan"
          ? classes.headerContainerAuthLayout
          : layoutContext.menuOpen
            ? classes.headerContainerMenuOpen
            : classes.headerContainerMenuClosed,
      )}
    >
      <div className={classes.header}>
        <div className={classes.container}>{children}</div>
      </div>
    </header>
  );
};
